import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {connect} from 'react-redux'
import setSearchCreatorAction from '../../redux/actions/searchReferenceActions/actionSearchCreator'
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-notchedOutline': {
    '&:hover': {
      borderColor: "rgb(0,191,255)",
    },
    '&.Mui-focused': {
      borderColor: "rgb(47, 79, 79)",
    },
  },
  '& .Mui-focused': {
    color: 'white',
  },
  width: 300,
  marginTop: 10,
  fontSize: 30,
  backgroundColor: 'rgba(19, 174, 236, 0.54)',
  fontWeight: 'bold'
});

class SearchCreatorForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      searchCreator: '', creators: [{creator:  ''}]};
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeForm = this.handleChangeForm.bind(this);
    this.props.setSearchCreatorFunction('');
  }

  // fetch by adding charachters in searchCreator-inputform
  async handleChange(event) {
    if(event.target.value.length > 0) {
    this.setState({ searchCreator: event.target.value});
  }
    if (this.state.searchCreator !== null && this.state.searchCreator.length >= 1) {
      const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/searchRef/creator?creator=${this.state.searchCreator}`);
      const json = await response.json();
      this.setState({ creators: [{creator: json.name}]});
    }
  };

  handleChangeForm(event, value) {

    if (value !== null) {
      this.setState({ searchCreator: value}, () => {
        this.props.setSearchCreatorFunction(this.state.searchCreator);
      });
    } else {
      this.setState({ searchCreator: ''}, () => {
        this.props.setSearchCreatorFunction(this.state.searchCreator);
      });
    }
  }

  render() {

    const { classes } = this.props;
    const { t } = this.props;

    return (
      <div>
        <Autocomplete
          classes={classes} 
          id="combo-box-creator"
          onChange={this.handleChangeForm}
          options={this.state.creators}
          isOptionEqualToValue={(option, value) => option.creators === value.creators}
          getOptionLabel={(option) => option.creator || ''}
          noOptionsText={'Wrong input data'}
          renderInput={(params) => <StyledTextField {...params} style={{ fontSize: 30, margin: 10, backgroundColor: 'rgba(19, 174, 236, 0.54)', width: 300 }} onChange={this.handleChange} label={t("view_ref.creator")} variant="outlined" />}        
        />
        </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
    return {
        setSearchCreatorFunction: searchCreator => [
            dispatch(setSearchCreatorAction(searchCreator))
        ] 
    }
}

export default connect(null, mapDispatchToProps)(withTranslation()(SearchCreatorForm)); 